import { z } from "zod";

import { productSettingsSchema } from "../productsSchema";

export const spendInsightsSettingsSchema = productSettingsSchema.extend({
  defaultReportDuration: z.string(),
  retryValidationFailures: z.boolean(),
  masterCardMatchReport: z.boolean(),
  genAIInsights: z.boolean(),
  creditReviewReport: z.boolean(),
  fileNamePrefix: z.string(),
  annualSupplierMinimumSpend: z.string(),
  spendAnalysisReport: z.boolean(),
  manualUpload: z.boolean(),
  payTechReport: z.boolean(),
  enableManualAccountingIntegrations: z.boolean(),
  spendSummaryReport: z.boolean(),
});

export type SpendInsightsSettings = z.infer<typeof spendInsightsSettingsSchema>;
